import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-navbar flex-shrink-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "app-navbar-item align-items-stretch ms-1 ms-lg-3" }, null, -1)
const _hoisted_3 = {
  id: "kt_header_lang_menu_toggle",
  class: "app-navbar-item ms-1 ms-lg-3 mt-1"
}
const _hoisted_4 = {
  class: "btn btn-hover-rise cursor-pointer symbol symbol-35px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LanguageMenu = _resolveComponent("LanguageMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          "aria-label": "lang_menu",
          title: "lang_menu",
          class: "w-15px h-15px rounded-1 ms-2",
          src: _ctx.currentLanguageLocale.flag,
          alt: "Flag of current language"
        }, null, 8, _hoisted_5)
      ]),
      _createVNode(_component_LanguageMenu)
    ])
  ]))
}